import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarWrapperService {

  sidebarState: boolean = false;
  options: any = {title: '', showTabs: true, activeTab: 1};
  constructor() { }

  openSidebar(options: any = {}){
    this.sidebarState = true;
    this.options = options;
  }

  closeSidebar(){
    this.sidebarState = false;
  }
}
